import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { ConstrainMode, DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import React, { Component, Fragment } from 'react';
import { DataSociete } from '../../data/DataSociete';
import { DataSocieteAPI } from '../../data/DataSocieteAPI';
import { DataSocieteNotificationPush } from '../../data/DataSocieteNotificationPush';
import { Immocom } from '../../specifique/immocom';
import { EUIDialog } from '../EUI/EUIDialog';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import { PickerSociete } from '../Picker/PickerSociete';

/*
**********************************************************************************************************************
PROPS :
    ATTRIBUTS :
        int?        idNotificationPush          n'afficher que les sociétés abonnées à cette notification push
        int?        idAPI                       n'afficher que les sociétés autorisées à consommer cette API
    METHODES :
        -
**********************************************************************************************************************
*/

export class DetailsListSociete extends Component {

    constructor(props) {
        super(props);
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        this._isSortedDescending = false;
        this._sortedColumn = "nom";
        this._objetState = {
            items: [],
            itemActif: {},
            /* --- */
            hideMessageBarFiltres: true,
            hideMessageBarWarning: true,
            hideMessageBarError: true
        };
        this.state = { ... this._objetState };
    };

    _creationContent = () => {
        return <DetailsList
            columns={this._columns}
            constrainMode={ConstrainMode.unconstrained}
            items={this.state.items}
            onColumnHeaderClick={this._onClickColumnHeader}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
            selectionMode={SelectionMode.none}
        />;
    }

    _abonnerSociete = () => {
        this._toggleDialog()();
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Abonnement en cours..."
        });

        const { idNotificationPush } = this.props;
        const { idSociete } = this.state.itemActif;
        DataSocieteNotificationPush._onEnregistrementSocieteNotificationPush({ idSociete, idNotificationPush })
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });
    };

    _desabonnerSociete = () => {
        this._toggleDialog()();
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Désabonnement en cours..."
        });

        const { idNotificationPush } = this.props;
        const { idSociete } = this.state.itemActif;

        DataSocieteNotificationPush._onSuppressionSocieteNotificationPush(idSociete, idNotificationPush)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });
    };

    _inscrireSociete = () => {
        this._toggleDialog()();
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Inscription en cours..."
        });

        const { idAPI } = this.props;
        const { idSociete } = this.state.itemActif;
        DataSocieteAPI._onEnregistrementSocieteAPI({ idSociete, idAPI })
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });
    };

    _desinscrireSociete = () => {
        this._toggleDialog()();
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Désinscription en cours..."
        });

        const { idAPI } = this.props;
        const { idSociete } = this.state.itemActif;
        DataSocieteAPI._onSuppressionSocieteAPI(idSociete, idAPI)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });
    };

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des sociétés en cours..."
        });

        let chargementSocietes = DataSociete._chargementSocietes(this._filtres, this._sortedColumn, this._isSortedDescending);
        chargementSocietes
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const listeSocietes = responseFetch.reponseAPIobjet || [];
                    const stateTemp = { items: listeSocietes };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    this.setState({ items: [] });
                    Immocom.onTraitementErreurPromise(this, retourVerif);
                }
            });
    };

    _getColumns = () => {
        let columns = [
            {
                isSorted: true,
                isSortedDescending: true,
                key: "nom",
                name: "Société",
                onRender: (item) => {
                    const nom = item.nom;
                    return <span title={nom}>{nom}</span>;
                }
            },
            {
                key: "urlPush",
                name: "URL",
                onRender: (item) => {
                    const urlPush = item.urlPush;
                    return <span title={urlPush}>{urlPush}</span>;
                }
            },
            {
                key: "endpointPush",
                name: "Endpoint",
                onRender: (item) => {
                    const endpointPush = item.endpointPush;
                    return <span title={endpointPush}>{endpointPush}</span>;
                }
            },
            {
                key: "login",
                name: "Login",
                onRender: (item) => {
                    const login = item.login;
                    return <span title={login}>{login}</span>;
                }
            },

        ];
        if (this.props.idAPI) columns.push(
            {
                iconName: null,
                isIconOnly: true,
                key: "desinscrire",
                minWidth: 25,
                maxWidth: 25,
                name: "Désinscrire cette société",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "Trash" }}
                        onClick={this._toggleDialog("desinscrire", item)}
                        title="Supprimer l'inscription à cette API"
                    />;
                }
            }
        );
        if (this.props.idNotificationPush) columns.push(
            {
                iconName: null,
                isIconOnly: true,
                key: "desabonner",
                minWidth: 25,
                maxWidth: 25,
                name: "Désabonner cette société",
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: "Trash" }}
                        onClick={this._toggleDialog("desabonner", item)}
                        title="Supprimer l'abonnement à cette notification push"
                    />;
                }
            }
        );
        return columns;
    };

    _getFiltres = () => {
        const { idNotificationPush, idAPI } = this.props;
        let filtres = {};
        if (idNotificationPush) filtres.idNotificationPush = idNotificationPush;
        if (idAPI) filtres.idAPI = idAPI;
        return filtres;
    };

    _getFarItems = () => {
        return [
            {
                key: "nombreEnregistrement",
                name: this.state.items.length
            }
        ];
    };

    _getItems = () => {
        const { idNotificationPush, idAPI } = this.props;
        let items = [
            {
                key: "search",
                onRender: () => <SearchBox
                    className="searchBox"
                    onClear={(ev) => this._onSearch("")}
                    onSearch={(newValue) => this._onSearch(newValue)}
                    placeholder="Recherche rapide"
                />
            },
        ];
        if (idNotificationPush) items.push({
            key: "abonner",
            name: "Abonner une société à cette notification push",
            iconProps: { iconName: "Streaming" },
            onClick: this._toggleDialog("abonner", true)
        });
        if (idAPI) items.push({
            key: "inscrire",
            name: "Inscrire une société à cette API",
            iconProps: { iconName: "Add" },
            onClick: this._toggleDialog("inscrire", true)
        });
        return items;
    };

    _onClickColumnHeader = (ev, column) => {
        const key = column.key;
        const isSortedDescending = !(column.isSortedDescending || false)

        this._columns.forEach((col) => {
            if (col.key === key) {
                col.isSortedDescending = isSortedDescending;
                col.isSorted = true;
            } else {
                col.isSorted = false;
                col.isSortedDescending = false;
            }
        });

        this._sortedColumn = key;
        this._isSortedDescending = isSortedDescending;
        this._chargementDonnees();
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender(props)}
        </Sticky>
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this._chargementDonnees();
    };

    _renderDialog = () => {
        const { afficherDialog, itemActif, nomDialogAffichee } = this.state;
        const pickerSociete = <PickerSociete onChange={(societe) => this.setState({ itemActif: societe || {} })} selectedKey={itemActif.idSociete} />;
        let dialogProps;
        switch (nomDialogAffichee) {
            case "abonner": dialogProps = { onClick: this._abonnerSociete, titre: "Abonnement d'une société", children: pickerSociete, disabled: !itemActif.idSociete }; break;
            case "desabonner": dialogProps = { onClick: this._desabonnerSociete, titre: "Désabonnement d'une société", message: "Confirmez-vous le désabonnement de cette société ?" }; break;
            case "inscrire": dialogProps = { onClick: this._inscrireSociete, titre: "Inscription d'une société", children: pickerSociete, disabled: !itemActif.idSociete }; break;
            case "desinscrire": dialogProps = { onClick: this._desinscrireSociete, titre: "Désinscription d'une société", message: "Confirmez-vous la déinscription de cette société ?" }; break;
            default: dialogProps = {}; break;
        };
        return <EUIDialog
            buttons={[
                <PrimaryButton key="confirm" onClick={dialogProps.onClick} text="Confirmer" disabled={dialogProps.disabled} />,
                <DefaultButton key="cancel" onClick={this._toggleDialog()} text="Annuler" />
            ]}
            isOpen={afficherDialog}
            message={dialogProps.message}
            onDismiss={this._toggleDialog()}
            titre={dialogProps.titre}
        >
            {dialogProps.children}
        </EUIDialog>;
    };

    _toggleDialog = (nomDialog, item) => () => {
        const afficherDialog = typeof nomDialog !== "undefined";
        let stateTemp = {
            afficherDialog,
            itemActif: item || {}
        };
        if (afficherDialog) stateTemp.nomDialogAffichee = nomDialog;
        this.setState(stateTemp);
    };

    componentDidMount = () => { this._chargementDonnees(); };

    // KP - 02/01/2023 : inutile, le périmètre n'influence pas le résultat
    //componentDidUpdate = () => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this._chargementDonnees();
    //    }
    //};

    render = () => {

        const content = this._creationContent();

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    ariaLabel={"Utiliser les flèches droite et gauche pour naviguer"}
                    farItems={this._getFarItems()}
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            {this._renderDialog()}

        </Fragment>;

    };

};